import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const backArrowStyles = {
  cursor: (): SystemStyleObject<Theme> => ({
    cursor: "pointer",
    "& :hover": {
      textDecoration: "underline",
    },
  }),
  label: (): SystemStyleObject<Theme> => ({
    fontSize: 16,
  }),
  button: (): SystemStyleObject<Theme> => ({
    padding: 0,
    textTransform: "lowercase",
  }),
};

export default backArrowStyles;
